import { ApolloError } from '@apollo/client/errors';
import { ModalForm, TControlledFormComponentProps, TControlledFormProps } from '@chocolate-soup-inc/cs-frontend-components';
import { joiResolver } from '@hookform/resolvers/joi';
import { useCallback } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getProductFormFields } from '../../entities/products/formFields';
import { getProductSchema } from '../../entities/products/schema';
import { TCreateProductMutationInput, useCreateProductMutation } from '../../generated/graphql';

export const GiftProductCreate = () => {
  const navigate = useNavigate();
  const [createProduct] = useCreateProductMutation();

  const closeModal = useCallback(() => {
    navigate(generatePath('../'));
  }, [navigate]);

  const onInvalidSubmit = useCallback<Exclude<TControlledFormProps<TCreateProductMutationInput>['onInvalidSubmit'], undefined>>((errors: Record<string, any>) => {
    console.error(errors);
    const submitError = errors[''];
    if (submitError) toast.error(submitError.message);
  }, []);

  const onSubmit = useCallback<TControlledFormProps<TCreateProductMutationInput>['onValidSubmit']>(
    (formData) => {
      return createProduct({
        variables: {
          input: formData
        }
      })
        .then(() => {
          toast.success('Successfully created the product.');
          closeModal();
        })
        .catch((error: ApolloError) => {
          toast.error('There was an error creating the product.');
          if (error instanceof ApolloError) error.graphQLErrors.forEach((err) => toast.error(err.message));
        });
    },
    [closeModal, createProduct]
  );
  return (
    <ModalForm
      headline='New Product'
      size='large'
      closeModal={closeModal}
      controlledFormProps={{
        fields: getProductFormFields() as TControlledFormComponentProps<TCreateProductMutationInput>[],
        formProps: {
          resolver: joiResolver(getProductSchema(), {
            convert: true,
            abortEarly: false,
            stripUnknown: false
          })
        },
        onValidSubmit: onSubmit,
        onInvalidSubmit: onInvalidSubmit
      }}
    />
  );
};
